/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Activities_TitleInputs */

const fr_vehicle_activities_title = /** @type {(inputs: Vehicle_Activities_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activités du véhicule`)
};

const en_vehicle_activities_title = /** @type {(inputs: Vehicle_Activities_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vehicle activities`)
};

/**
* | output |
* | --- |
* | "Vehicle activities" |
*
* @param {Vehicle_Activities_TitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_activities_title = /** @type {((inputs?: Vehicle_Activities_TitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Activities_TitleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_activities_title(inputs)
	return en_vehicle_activities_title(inputs)
});